import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom/dist';
import { AuthProvider } from "./context/AuthContext.jsx";
//import all necessary stylesheets to apply to all the app
import './assets/stylesheets/login.css.scss';
import './assets/stylesheets/custom.css.scss';
import './assets/stylesheets/mui-custom.css.scss';
import './assets/stylesheets/material.min.css.scss';
import './assets/stylesheets/material_icons.css.scss';
import './assets/stylesheets/drawer.css.scss';
import './assets/stylesheets/home.css.scss';
import './assets/stylesheets/graphs.css.scss';
import './assets/stylesheets/delivery_zones.scss';
import './assets/stylesheets/material.min.css.map';
import './assets/stylesheets/mdl-ext.min.css';
import './assets/stylesheets/mdl-ext.min.css.map';
import './assets/stylesheets/forgotten.css.scss';
import './assets/stylesheets/select-ecommerce.css.scss';
import './assets/stylesheets/users.css.scss';
import './assets/stylesheets/select-type.css.scss';
import './assets/stylesheets/custom-table.css.scss';
import './assets/stylesheets/pending-requests.css.scss';
import './assets/stylesheets/requests-success-upload.css.scss';
import './assets/stylesheets/inventory-seller-row.css.scss';
import './assets/stylesheets/product-details.css.scss';
import 'material-icons/iconfont/material-icons.css';
import './assets/stylesheets/tracking.css.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
